(() => {
  const selector = '.pn-product-hero--quantum .thumbnail-slider';

  function initThumbnailRail(rail) {
    if (rail.dataset.pnVerticalRailReady === 'true') return;

    const list = rail.querySelector('.thumbnail-list');
    const previous = rail.querySelector('.slider-button--prev');
    const next = rail.querySelector('.slider-button--next');
    if (!list || !previous || !next) return;

    rail.dataset.pnVerticalRailReady = 'true';

    const updateControls = () => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        previous.hidden = true;
        next.hidden = true;
        return;
      }

      const hasOverflow = list.scrollHeight > list.clientHeight + 2;
      previous.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      previous.disabled = !hasOverflow || list.scrollTop <= 2;
      next.disabled = !hasOverflow || list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
    };

    const scrollRail = (direction) => {
      list.scrollBy({
        top: direction * Math.max(list.clientHeight * 0.7, 112),
        behavior: 'smooth',
      });
    };

    previous.addEventListener('click', (event) => {
      if (window.matchMedia('(max-width: 749px)').matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      scrollRail(-1);
    }, true);

    next.addEventListener('click', (event) => {
      if (window.matchMedia('(max-width: 749px)').matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      scrollRail(1);
    }, true);

    let pointerId;
    let startY = 0;
    let startScrollTop = 0;
    let dragged = false;

    list.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || window.matchMedia('(max-width: 749px)').matches) return;
      pointerId = event.pointerId;
      startY = event.clientY;
      startScrollTop = list.scrollTop;
      dragged = false;
    });

    list.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const distance = event.clientY - startY;
      if (Math.abs(distance) > 4 && !dragged) {
        dragged = true;
        list.setPointerCapture(pointerId);
        list.classList.add('is-dragging');
      }
      if (dragged) list.scrollTop = startScrollTop - distance;
    });

    const stopDragging = (event) => {
      if (event.pointerId !== pointerId) return;
      if (list.hasPointerCapture(pointerId)) list.releasePointerCapture(pointerId);
      pointerId = undefined;
      if (dragged) list.dataset.pnSuppressThumbnailClick = 'true';
      list.classList.remove('is-dragging');
    };

    list.addEventListener('pointerup', stopDragging);
    list.addEventListener('pointercancel', stopDragging);
    list.addEventListener('click', (event) => {
      if (dragged) {
        event.preventDefault();
        event.stopImmediatePropagation();
        dragged = false;
        return;
      }

      const button = event.target.closest('button.thumbnail');
      const item = button?.closest('[data-target]');
      const gallery = rail.closest('media-gallery');
      const mediaId = item?.dataset.target;
      if (!button || !gallery || !mediaId) return;

      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      const mediaList = viewer?.querySelector('[id^="Slider-Gallery"]');
      const mediaItems = mediaList
        ? Array.from(mediaList.querySelectorAll('.product__media-item[data-media-id]'))
        : [];
      const activeMedia = mediaItems.find((media) => media.dataset.mediaId === mediaId);
      if (!activeMedia) return;

      event.stopImmediatePropagation();

      mediaItems.forEach((media) => media.classList.remove('is-active'));
      activeMedia.classList.add('is-active');

      rail.querySelectorAll('button.thumbnail').forEach((thumbnail) => {
        thumbnail.removeAttribute('aria-current');
      });
      button.setAttribute('aria-current', 'true');

      if (window.matchMedia('(max-width: 749px)').matches) {
        mediaList.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
      }
    }, true);

    list.addEventListener('scroll', updateControls, { passive: true });
    new ResizeObserver(updateControls).observe(list);
    updateControls();
  }


  function switchGalleryMedia(event) {
    const button = event.target.closest(
      '.pn-product-hero--quantum .thumbnail-slider button.thumbnail'
    );
    if (!button) return;

    const item = button.closest('[data-target]');
    const list = button.closest('.thumbnail-list');
    const gallery = button.closest('media-gallery');
    const mediaId = item?.dataset.target;
    if (!item || !list || !gallery || !mediaId) return;

    if (list.dataset.pnSuppressThumbnailClick === 'true') {
      delete list.dataset.pnSuppressThumbnailClick;
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const mediaList = gallery.querySelector('[id^="Slider-Gallery"]');
    const mediaItems = mediaList
      ? Array.from(mediaList.querySelectorAll('.product__media-item[data-media-id]'))
      : [];
    const activeMedia = mediaItems.find((media) => media.dataset.mediaId === mediaId);
    if (!activeMedia) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    mediaItems.forEach((media) => media.classList.remove('is-active'));
    activeMedia.classList.add('is-active');

    gallery.querySelectorAll('.thumbnail-slider button.thumbnail').forEach((thumbnail) => {
      thumbnail.removeAttribute('aria-current');
    });
    button.setAttribute('aria-current', 'true');

    if (window.matchMedia('(max-width: 749px)').matches) {
      mediaList.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
    }
  }

  document.addEventListener('click', switchGalleryMedia, true);

  function initAll() {
    document.querySelectorAll(selector).forEach(initThumbnailRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
